var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_52_63092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 39C77 56.6731 62.6731 71 45 71C27.3269 71 13 56.6731 13 39C13 21.3269 27.3269 7 45 7C62.6731 7 77 21.3269 77 39Z",
    fill: "url(#paint0_linear_52_63092)",
    stroke: "white",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6914 41.5583L37.8439 53.0517C37.8439 53.0517 38.363 54.127 38.9189 54.127C39.4749 54.127 47.7433 45.5252 47.7433 45.5252L56.9381 27.7656L33.8396 38.5914L33.6914 41.5583Z",
    fill: "#C8DAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1978 44.5059L38.4007 52.9776C38.4007 52.9776 38.067 55.5734 40.6623 52.9776C43.2575 50.3818 45.7416 48.3801 45.7416 48.3801",
    fill: "#A9C6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7669 41.9688L25.2251 39.1858C25.2251 39.1858 24.2043 38.7716 24.533 37.8324C24.6007 37.6388 24.7372 37.474 25.1455 37.1908C27.0381 35.8716 60.1764 23.9608 60.1764 23.9608C60.1764 23.9608 61.1121 23.6455 61.6639 23.8552C61.8004 23.8974 61.9233 23.9752 62.0199 24.0805C62.1165 24.1858 62.1834 24.3149 62.2137 24.4546C62.2733 24.7012 62.2983 24.955 62.2878 25.2085C62.2852 25.4278 62.2586 25.6311 62.2385 25.9499C62.0367 29.2064 55.9968 53.5104 55.9968 53.5104C55.9968 53.5104 55.6354 54.9326 54.3407 54.9813C54.0226 54.9915 53.7056 54.9376 53.4087 54.8228C53.1118 54.7079 52.841 54.5345 52.6126 54.3128C50.0719 52.1273 41.2904 46.2257 39.3499 44.9278C39.3062 44.898 39.2693 44.8591 39.2418 44.8138C39.2144 44.7685 39.1969 44.7179 39.1907 44.6653C39.1636 44.5285 39.3123 44.3591 39.3123 44.3591C39.3123 44.3591 54.6032 30.7674 55.0101 29.3406C55.0416 29.23 54.9226 29.1755 54.7628 29.2239C53.7472 29.5975 36.1416 40.7156 34.1985 41.9426C34.0587 41.9849 33.9108 41.9939 33.7669 41.9688Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_52_63092",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_52_63092"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_52_63092",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_63092",
    x1: 45,
    y1: 74,
    x2: 45,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D93D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B0E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIc);
export default __webpack_public_path__ + "static/media/telegram_ic.f29ac7bf.svg";
export { ForwardRef as ReactComponent };